import { useEffect } from 'react';

export const SCROLL_LOCKED_CLASS_NAME = 'modalOpen';

export class BodyScrollLock {
  static lock() {
    const { body } = document;
    if (body.classList.contains(SCROLL_LOCKED_CLASS_NAME)) {
      return;
    }

    const offsetWidth = window.innerWidth;
    const scrollbarWidth = offsetWidth - body.scrollWidth;

    Object.assign(body.style, {
      position: 'fixed',
      overflow: 'hidden',
      top: `-${window.scrollY}px`,
      left: `-${window.scrollX}px`,
      right: '0',
      paddingRight: `${scrollbarWidth}px`,
    });
    body.classList.add(SCROLL_LOCKED_CLASS_NAME);
  }

  static unlock() {
    const { body } = document;
    if (!body.classList.contains(SCROLL_LOCKED_CLASS_NAME)) {
      return;
    }

    const scrollX = parseInt(body.style.left.replace('px', '') || '0', 10) * -1;
    const scrollY = parseInt(body.style.top.replace('px', '') || '0', 10) * -1;

    Object.assign(body.style, {
      position: '',
      top: '',
      left: '',
      right: '',
      overflowY: '',
      overflowX: '',
      paddingRight: 0,
    });

    window.scrollTo({
      top: scrollY,
      left: scrollX,
      behavior: 'instant',
    });
    body.classList.remove(SCROLL_LOCKED_CLASS_NAME);
  }

  static isLocked() {
    return document.body.classList.contains(SCROLL_LOCKED_CLASS_NAME);
  }
}

export const useBodyScrollLock = (isVisible: boolean) => {
  useEffect(() => {
    if (isVisible) {
      BodyScrollLock.lock();
    } else {
      BodyScrollLock.unlock();
    }
    return () => {
      BodyScrollLock.unlock();
    };
  }, [isVisible]);
};
